// extracted by mini-css-extract-plugin
export default {"root":"testimonials_root__d2979","title":"testimonials_title__1gVFX","comment_wrapper":"testimonials_comment_wrapper__jZBxZ"};